// Core
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

// Assets

// Styles
import Button from '../Button';
import { HeaderOuter, HeaderWrapper, LogoText, TopMenu } from './styles';

const Header: React.FC = () => {
    const { t } = useTranslation();

    return (
        <HeaderOuter>
            <div className='container'>
                <HeaderWrapper>
                    <LogoText ><NavLink to={'home'} end>Ahlamakom</NavLink></LogoText>
                    <TopMenu>
                        <NavLink to={'about'} end>{t('about_us')}</NavLink>
                        <NavLink to={'contact'} end>{t('contact_us')}</NavLink>
                        <NavLink to={'privacy'} end>{t('privacy_policy')}</NavLink>
                        <NavLink to={'cookie'} end>{t('cookies_policy')}</NavLink>
                    </TopMenu>
                    <button >Login</button>
                </HeaderWrapper>
            </div>
        </HeaderOuter>
    );
};

export default Header;
